'use strict';

import $ from 'jquery';

const init = () => {
    const $body = $('body');
    let lastScrollTop = 0;

    const onScroll = () => {
        const scroll = $(window).scrollTop() ?? 0;

        if (scroll >= 90) {
            $body.addClass('minimize-header');
        } else {
            $body.removeClass('minimize-header');
        }
    };

    window.addEventListener('scroll', onScroll, false);
};

export default {init};
